// extracted by mini-css-extract-plugin
export default {"loaderV2":"Loader_loaderV2__wwDm8","backdrop":"Loader_backdrop__cxrM4","backdropDark":"Loader_backdropDark__PvhB4","progressContainer":"Loader_progressContainer__C1EZJ"};